import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './menuIcon.css'
import InputRange from 'react-input-range';
import "react-input-range/lib/css/index.css";
import { getAdvanceSearchResults } from '../components/UserFunctions'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types';

class AdvanceSearchModal extends Component{
    constructor(props){
        super(props);
        this.state = {
            tp_value: { min: 0, max: 100 },
            fp_value: { min: 0, max: 100 },
            fn_value: { min: 0, max: 100 },
            precision_value: { min: 0, max: 100 },
            recall_value: { min: 0, max: 100 },
            f1_value: { min: 0, max: 100 },

            search_option: "Class",
            search_clicked: false,
            searched_list:[],
            searched_runs:[],
          };
    }

    onChangeValue = (event) => {
        this.setState({
            search_option: event.target.value
        })
      }

    onBackClick(){
        this.setState({
            search_clicked: false,
        })
    }

    onSearchClick(){
        var searched_runs = [];
        if(this.state.search_option==="Class"){
            for (var i = 0; i < this.state.searched_list.length; i++) {
                if(this.state.searched_list[i][1]>=this.state.tp_value.min && this.state.searched_list[i][1]<=this.state.tp_value.max
                    && this.state.searched_list[i][2]>=this.state.fp_value.min && this.state.searched_list[i][2]<=this.state.fp_value.max
                    && this.state.searched_list[i][3]>=this.state.fn_value.min && this.state.searched_list[i][3]<=this.state.fn_value.max){
                        searched_runs.push(this.state.searched_list[i][0])
                }
            }
        }
        else{
            for (i = 0; i < this.state.searched_list.length; i++) {
                if(this.state.searched_list[i][4]>=this.state.precision_value.min && this.state.searched_list[i][4]<=this.state.precision_value.max
                    && this.state.searched_list[i][5]>=this.state.recall_value.min && this.state.searched_list[i][5]<=this.state.recall_value.max
                    && this.state.searched_list[i][6]>=this.state.f1_value.min && this.state.searched_list[i][6]<=this.state.f1_value.max){
                        searched_runs.push(this.state.searched_list[i][0])
                }
            }
        }

        this.setState({
            searched_runs,
            search_clicked:true
        })

    }

    componentDidMount(){
        getAdvanceSearchResults().then(res => {
            // console.log(res);
            if(res !== undefined){
                this.setState({
                    searched_list:res.data.data,
                })

          }
        });
    }

    render(){
        return(
            <div data-test='advanceSearchModalComponent'>


                <Modal isOpen={true}>
                    <ModalHeader
                        toggle={this.props.closeSearchModal}
                        style={{ color:"#524fa1" }}
                    >
                        Advance Search
                    </ModalHeader>

                    {this.state.search_clicked === false?
                    <ModalBody>
                    <div className="card">
                      <div className="card-body">
                      <div onChange={this.onChangeValue}>
                            Search by:&nbsp;&nbsp;&nbsp;
                            <input type="radio" value="Class" name="option" checked={this.state.search_option === "Class"}/> TP/FP/FN &nbsp;&nbsp;
                            <input type="radio" value="Metrics" name="option" checked={this.state.search_option === "Metrics"}/> Metrics
                      </div>

                    {this.state.search_option === "Class"?
                        <form>
                            <div className="form-group">
                            <div style={{marginBottom : "20px",marginTop: "20px"}}>True Positive : </div>
                                <InputRange
                                    maxValue={100}
                                    minValue={0}
                                    value={this.state.tp_value}
                                    onChange={tp_value => this.setState({ tp_value })} /><br />
                            </div>
                            <div className="form-group">
                            <div style={{marginBottom : "20px",marginTop: "20px"}}> False Positive : </div>
                                <InputRange
                                    maxValue={100}
                                    minValue={0}
                                    value={this.state.fp_value}
                                    onChange={fp_value => this.setState({ fp_value })} /><br />
                            </div>
                            <div className="form-group">
                            <div style={{marginBottom : "20px",marginTop: "20px"}}>False Negative :</div>
                                <InputRange
                                    maxValue={100}
                                    minValue={0}
                                    value={this.state.fn_value}
                                    onChange={fn_value => this.setState({ fn_value })} /><br />
                            </div>
                            </form>
                            :
                            <form>
                            <div className="form-group">
                            <div style={{marginBottom : "20px",marginTop: "20px"}}>Recall : </div>
                                <InputRange
                                    maxValue={100}
                                    minValue={0}
                                    value={this.state.recall_value}
                                    onChange={recall_value => this.setState({ recall_value })} /><br />
                            </div>
                            <div className="form-group">
                            <div style={{marginBottom : "20px",marginTop: "20px"}}>Precision : </div>
                                <InputRange
                                    maxValue={100}
                                    minValue={0}
                                    value={this.state.precision_value}
                                    onChange={precision_value => this.setState({ precision_value })} /><br />
                            </div>
                            <div className="form-group">
                            <div style={{marginBottom : "20px",marginTop: "20px"}}>F1-Score : </div>
                                <InputRange
                                    maxValue={100}
                                    minValue={0}
                                    value={this.state.f1_value}
                                    onChange={f1_value => this.setState({ f1_value })} /><br />
                            </div>
                        </form>
                    }
                      </div>
                    </div>

                    </ModalBody>
                    :
                    <ModalBody>
                    <ul>
                        {this.state.searched_runs.map((value, index) => {
                            return <li key={index}><Link to={{
                                                        pathname :"/camera_dashboard_level3",
                                                        runid:value
                                                        }} onClick={this.props.closeSearchModal}>
                                                {value}

                                             </Link></li>
                        })}
                    </ul>
                    </ModalBody>
                    }
                    <ModalFooter>
                    {this.state.search_clicked === false?
                      <Button color="" className="btn btn-primary" onClick={() => this.onSearchClick()}>Search</Button>
                    :
                    <Button color="" className="btn btn-primary" onClick={() => this.onBackClick()}>Back</Button>

                    }
                    </ModalFooter>
                  </Modal>

            </div>

        )
    }
}
AdvanceSearchModal.propTypes={
closeSearchModal:PropTypes.string,
//navigateHome:PropTypes.string,
}
AdvanceSearchModal.defaultProps= {
closeSearchModal:[],
//navigateHome:[],
}
// onChangeValue = (event) => {
//     this.setState({
//         search_option: event.target.value
//     })
//   }

// onBackClick(){
//     this.setState({
//         search_clicked: false,
//     })
// }

// onSearchClick(){
//     var searched_runs = [];
//     if(this.state.search_option==="Class"){
//         for (var i = 0; i < this.state.searched_list.length; i++) {
//             if(this.state.searched_list[i][1]>=this.state.tp_value.min && this.state.searched_list[i][1]<=this.state.tp_value.max
//                 && this.state.searched_list[i][2]>=this.state.fp_value.min && this.state.searched_list[i][2]<=this.state.fp_value.max
//                 && this.state.searched_list[i][3]>=this.state.fn_value.min && this.state.searched_list[i][3]<=this.state.fn_value.max){
//                     searched_runs.push(this.state.searched_list[i][0])
//             }
//         }
//     }
//     else{
//         for (var i = 0; i < this.state.searched_list.length; i++) {
//             if(this.state.searched_list[i][4]>=this.state.precision_value.min && this.state.searched_list[i][4]<=this.state.precision_value.max
//                 && this.state.searched_list[i][5]>=this.state.recall_value.min && this.state.searched_list[i][5]<=this.state.recall_value.max
//                 && this.state.searched_list[i][6]>=this.state.f1_value.min && this.state.searched_list[i][6]<=this.state.f1_value.max){
//                     searched_runs.push(this.state.searched_list[i][0])
//             }
//         }
//     }

//     this.setState({
//         searched_runs,
//         search_clicked:true
//     })

// }

// componentDidMount(){
//     getAdvanceSearchResults().then(res => {
//         // console.log(res);
//         if(res !== undefined){
//             this.setState({
//                 searched_list:res.data.data,
//             })

//       }
//     });
// }


export default AdvanceSearchModal
